import * as React from "react";
import styled from "react-emotion";
import { getExposureEvent, searchExposureEvents } from "../../../api/models/Exposure";
import { Field, Control, Input } from "bloomer";
import { isEmpty } from "lodash";
import Card from "../../../elements/Card";
import { H2 } from "../../../elements/Heading";
import SendGAEvent, {GAEventActions, GAEventModels} from "../../../utils/SendGAEvent";
import ErrorUtils from "../../../utils/ErrorUtils";
import {toast} from "react-toastify";
import ModelContentContainer from "../../../elements/ModelContentContainer";

const SearchResult = styled("div")`
  border-bottom: 1px solid lightgrey;
  display: flex;

  :hover {
    cursor: pointer;
    color: white !important;
    background: #2f3241 !important;
  }
`;

const SelectedEvent = styled(H2)`
  margin: 0;
  margin-right: 5px;
`;

const InformationContainer = styled("div")`
  display: flex;
  flex-direction: column;
`;

const InformationCard = styled("div")`
  border: 1px solid lightgrey;
  border-radius: 5px;
  padding: 5px;
  min-height: 50px;
  margin: 5px;
  max-width: 800px !important;
`;

const InformationHeading = styled("span")`
  margin-left: 5px;
  font-weight: 500;
`;

const AffectedAsset = styled("span")`
  padding: 4px;
  border: 1px solid lightgrey;
  border-radius: 3px;
  font-weight: 700;
`;

const AffectedAssetDescription = styled("span")`
  padding: 4px;
`;

const Asset = styled("div")`
  display: flex;
  flex-direction: column;
  margin: 10px;
`;

interface ISearchExposureEvent {
  event: string;
}

interface IExposureEvent {
  asset_affected: string[];
  description: {
    exposure_score: number;
    median_price_change: number;
    name: string;
  };
  event: string;
}

interface ISelectorState {
  searchResults: ISearchExposureEvent[];
  currentInput: string;
  selectedEvent: ISearchExposureEvent;
  modelOutput: IExposureEvent[];
}

class ExposureModel extends React.Component<{}, ISelectorState> {
  public constructor(props: {}) {
    super(props);
    this.state = {
      searchResults: [],
      currentInput: "",
      selectedEvent: { event: "" },
      modelOutput: [
        {
          asset_affected: [],
          description: {
            exposure_score: null,
            median_price_change: null,
            name: ""
          },
          event: ""
        }
      ]
    };
  }

  public componentDidMount() {
    SendGAEvent(GAEventActions.VIEW_MODEL, GAEventModels.EXPOSURE_ANALYZER);
  }

  public handleChange = async (event: React.FormEvent<HTMLInputElement>) => {
    const input = event.currentTarget.value;
    this.setState({ currentInput: input, searchResults: null });
    if (input.length === 0) {
      this.setState({
        selectedEvent: { event: "" }
      });
    }
    const events = !isEmpty(input) ? await searchExposureEvents(input) : "";
    // @ts-ignore:
    this.setState({ searchResults: events });
  };

  public selectEvent = async (event: ISearchExposureEvent) => {
    let errorOccurred = false;

    const response = await getExposureEvent(event.event).catch((error) => {
      if (ErrorUtils.requestLimitExceeded(error.response)) {
        toast.error(ErrorUtils.messageContent.REQUEST_LIMIT_EXCEEDED);
      }
      errorOccurred = true;
    });

    if (errorOccurred) {
      return;
    }

    if (response) {
      const name = event.event;
      this.setState({selectedEvent: {event: name}, modelOutput: response.data});

      SendGAEvent(GAEventActions.CALL_MODEL, GAEventModels.EXPOSURE_ANALYZER);
    }
  };

  public render() {
    return (
      <React.Fragment>
        <ModelContentContainer>
          <Card>
            <Field>
              <Control>
                <Input
                  type="text"
                  placeholder="Enter an event for exposure analysis"
                  value={this.state.currentInput}
                  onChange={this.handleChange}
                />
              </Control>
            </Field>
            {!isEmpty(this.state.searchResults) &&
              isEmpty(this.state.selectedEvent.event) &&
              this.state.searchResults.map((result: IExposureEvent) => (
                <SearchResult
                  key={result.event + Math.random()}
                  onClick={() => {
                    this.selectEvent(result);
                  }}
                >
                  {result.event}
                </SearchResult>
              ))}

            {!isEmpty(this.state.selectedEvent.event) &&
            !isEmpty(this.state.modelOutput) ? (
              <React.Fragment>
                <div style={{ display: "flex", marginLeft: "5px" }}>
                  <SelectedEvent>
                    {" "}
                    {this.state.selectedEvent.event.slice(0, 60)}{" "}
                  </SelectedEvent>
                </div>
                <InformationContainer>
                  <InformationHeading>Affected Assets</InformationHeading>
                  <InformationCard>
                    {this.state.modelOutput.map((e: IExposureEvent) => (
                      <Asset>
                        {e.asset_affected && (
                          <AffectedAsset>{e.asset_affected[0]}</AffectedAsset>
                        )}
                        {e.description && (
                          <AffectedAsset>
                            {e.description.name}
                          </AffectedAsset>
                        )}
                        {e.description && (
                          <AffectedAssetDescription>
                            Exposure Score: {e.description.exposure_score}
                          </AffectedAssetDescription>
                        )}
                        {e.description && (
                          <AffectedAssetDescription>
                            {" "}
                            Median Price Change:{" "}
                            {e.description.median_price_change}
                          </AffectedAssetDescription>
                        )}
                      </Asset>
                    ))}
                  </InformationCard>
                </InformationContainer>
              </React.Fragment>
            ) : (
              ""
            )}
          </Card>
        </ModelContentContainer>
      </React.Fragment>
    );
  }
}

export default ExposureModel;



// WEBPACK FOOTER //
// ./src/routes/Dashboard/Exposure/ExposureModel.tsx